import { createIcon } from '@chakra-ui/react'

/** Logo icon */
const ProfileIcon = createIcon({
  d: 'M25.017 5.072c-6.395 0-11.58 5.184-11.58 11.58 0 6.394 5.185 11.578 11.58 11.578 6.395 0 11.579-5.184 11.579-11.579 0-6.395-5.184-11.579-11.58-11.579M18.54 30.16c-8.155 0-14.768 6.612-14.768 14.768H46.23c0-8.156-6.613-14.768-14.768-14.768H18.539',
  viewBox: '0 0 50 50',
  displayName: 'Profile Icon'
})

export default ProfileIcon
